import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import shipingService from "../services/shiping-service";
import cogoToast from "cogo-toast";
import CutOffPopUp from "../Components/CutOffPopUp";
import Loader from "react-loader-spinner";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData } from "ka-table/actionCreators";
import { PagingPosition } from "ka-table/enums";
const tablePropsInit = {
  columns: [
    { key: "fac_id", title: "Facility Id" },
    { key: "fac_name", title: "Facility Name" },
    { key: "fac_code", title: "DCode" },
    { key: "status", title: "Audit Status" },
  ],
  singleAction: loadData(),
  rowKeyField: "id",
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};
const PackingSlipTab = ({ history, cutOffList }) => {
  const [loading, setLoading] = useState(false);
  const [edituserOpen, setEditUserOpen] = useState(false);
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const [showFacilityList, setShowFacilityList] = useState("hidden");
  const [showPublish, setShowPublish] = useState("hidden");
  async function runEODReport(reportType) {
    setLoading(true);
    try {
      let resp = await shipingService.runReportEOD(reportType);
      if (resp.length > 0) {
        if (reportType) {
          setShowPublish("");
        } else {
          setShowPublish("hidden");
        }
        setShowFacilityList("");
        dispatch1(updateData(resp));
      } else {
        const { hide } = cogoToast.error("No Records Found.", {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        });
        setLoading(false);
        setShowFacilityList("hidden");
        dispatch1(updateData([]));
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error retrieving End of day report. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
    setLoading(false);
  }
  async function publishPackingSlip() {
    setLoading(true);
    try {
      await shipingService.packingSlipPublish();
      setShowFacilityList("hidden");
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error publishing packaging slip. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  }
  let dispatch1 = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
  };
  const CustomCell = ({ rowData }) => {
    return (
      <div className="text-sm text-center">
        {rowData?.status ? (
          <>
            <img
              src="./img/packingInactive.svg"
              className="m-auto w-4 h-4"
              alt="delete"
              title="Active"
            />
          </>
        ) : (
          <>
            <img
              src="./img/packingActive.svg"
              className="m-auto w-4 h-4"
              alt="delete"
              title="Inactive"
            />
          </>
        )}
      </div>
    );
  };
  return (
    <div className="">
      <div
        className={`inline-block customtop z-50 absolute ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000}
        />
      </div>
      <div className="p-2">
        <ul>
          <li className="inline-block text-xs leading-6 text-menu_txt w-1/2">
            <button
              onClick={() => {
                runEODReport(false);
              }}
              type="submit"
              className="w-3/4 bg-header_bg rounded 
              text-xs focus:outline-none float-left py-2 px-2 cursor-pointer font-bold 
              text-white h-10 inline-block shadow-md leading-6"
            >
              AUDIT NOT COMPLETE REPORT
            </button>
          </li>
          <li className="inline-block text-xs leading-6 text-menu_txt w-1/2">
            <button
              onClick={() => {
                runEODReport(true);
              }}
              type="submit"
              className="text-white w-full sm:w-auto
              bg-header_bg rounded capitalize 
              focus:outline-none float-right               
              py-2 px-4 cursor-pointer text-xs font-bold h-10 inline-block shadow-md leading-6
              "
            >
              SEND PACKING SLIP
            </button>
          </li>
        </ul>
      </div>
      <div
        className={`inline-block customtop w-full packingSlipTable ${showFacilityList}`}
      >
        <button
          onClick={publishPackingSlip}
          type="submit"
          className={`text-white w-full sm:w-auto h-8 px-6 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none float-right inline-block mb-4 ${showPublish}`}
        >
          PUBLISH
        </button>
        <div className="p-2 text-xs gridList overflow-x-auto">
        <Table
          {...tableProps}
          childComponents={{
            cellText: {
              content: (props) => {
                // eslint-disable-next-line default-case
                switch (props.column.key) {
                  case "status":
                    return <CustomCell {...props} />;
                }
              },
            },
          }}
          dispatch={dispatch1}
        />
        </div>
      </div>
      <CutOffPopUp
        setEditUserOpen={setEditUserOpen}
        edituserOpen={edituserOpen}
      />
    </div>
  );
};
export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(PackingSlipTab)
);
